import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { PushMessage } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
@Component({
  selector: 'web-components-snackbar-ticket-msg',
  templateUrl: './snackbar-ticket-msg.component.html',
  imports: [RouterLink, DatePipe, TranslocoPipe],
})
export class SnackbarTicketMsgComponent {
  @Input() public pushMsg: PushMessage;
  public commonRoutes = commonRoutes;
}
